import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import PrivateRoute from "./routes/ProtectedRoute";
import AdminRoute from "./routes/AdminRoute";
import { initialize_auth } from "./redux/actions/auth";

import Signup from "./containers/auth/Signup";
import Login from "./containers/auth/Login";
import Activate from "./containers/auth/Activate";
import ResetPassword from "./containers/auth/ResetPassword";
import ResetPasswordConfirm from "./containers/auth/ResetPasswordConfirm";

import Error404 from "./containers/errors/Error404";
import Home from "./containers/Home";

import OfertasList from "./containers/ofertas/OfertasList";
import OfertaDetail from "./containers/ofertas/OfertaDetail";
import OfertaPartner from "./containers/ofertas/OfertaPartner";
import OfertaPagador from "./containers/ofertas/OfertaPagador";
import OfertaCups from "./containers/ofertas/OfertaCups";
import OfertaTarifa from "./containers/ofertas/OfertaTarifa";
import VirtualBatteryScreen from "./containers/bateriaVirtual/VirtualBatteryScreen";
import OfertaDocumentacion from "./containers/ofertas/OfertaDocumentacion";

import ContratoDetail from "./containers/ofertas/ContratoDetail";
import ContratosList from "./containers/ofertas/ContratosList";
import MiPerfil from "./containers/auth/MiPerfil";
import ResourceManager from "./containers/ofertas/ResourceManager";
import Resources from "./containers/ofertas/Resources";
import Novedades from "./containers/Novedades";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initialize_auth());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="*" element={<Error404 />} />
        <Route path="/" element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
        />

        {/* Authentication */}
        <Route path="/signup" element={
          <AdminRoute>
            <Signup />
          </AdminRoute>
        }
        />
        <Route path="/profile" element={
          <PrivateRoute>
            <MiPerfil />
          </PrivateRoute>
        }
        />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/activate/:uid/:token" element={<Activate />} />
        <Route exact path="/reset_password" element={<ResetPassword />} />
        <Route exact path="/password/reset/confirm/:uid/:token" element={<ResetPasswordConfirm />} />

        {/* Ofertas */}
        <Route path="/contratos/ofertas" element={
          <PrivateRoute>
            <OfertasList />
          </PrivateRoute>
        }
        />
        <Route path="/contratos/ofertas/:oferta_id" element={
          <PrivateRoute>
            <OfertaDetail />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/tarifas" element={
          <PrivateRoute>
            <OfertaTarifa />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/tarifas/:oferta_id" element={
          <PrivateRoute>
            <OfertaTarifa />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/partner/:oferta_id" element={
          <PrivateRoute>
            <OfertaPartner />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/pagador/:oferta_id" element={
          <PrivateRoute>
            <OfertaPagador />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/cups/:oferta_id" element={
          <PrivateRoute>
            <OfertaCups />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/cups/:oferta_id/bateria-virtual" element={
          <PrivateRoute>
            <VirtualBatteryScreen />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/bateria-virtual/:oferta_id" element={
          <PrivateRoute>
            <VirtualBatteryScreen />
          </PrivateRoute>
        }
        />
        <Route path="/:sector_type/documentacion/:oferta_id" element={
          <PrivateRoute>
            <OfertaDocumentacion />
          </PrivateRoute>
        }
        />

        {/* contratos */}
        <Route path="/contratos/contratos" element={
          <PrivateRoute allowCallAgent={false}>
            <ContratosList />
          </PrivateRoute>
        }
        />
        <Route path="/contratos/contratos/:contrato_id" element={
          <PrivateRoute allowCallAgent={false}>
            <ContratoDetail />
          </PrivateRoute>
        }
        />

        {/* Admin */}
        <Route path="/admin/recursos" element={
          <AdminRoute>
            <ResourceManager />
          </AdminRoute>
        }
        />
        <Route path="/recursos" element={
          <PrivateRoute>
            <Resources />
          </PrivateRoute>
        }
        />
        <Route path="/novedades" element={
          <PrivateRoute>
            <Novedades />
          </PrivateRoute>
        }
        />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
